import React from 'react';
import { actionTypes } from '../../constants';
import { getCurrentUrlPath } from '../helpers/HelperFunctions';
import { Table } from '../table/Table';
import i18next from "../../i18n";
import * as ListOfContracts from './ListOfContracts';
import { actionHandlerCallback as pActionHandlerCallback } from './ListOfDocuments';
export { getAllowedEnumValues, getFilterValuesFromMenu, getSelectedMenuItem, inboxNavigate, loadDocuments, getSettingsValue } from './ListOfDocuments';
export function actionHandlerCallback(type, ids = []) {
    const { content } = this.state;
    // eslint-disable-next-line default-case
    switch (type) {
        case actionTypes.preview: pActionHandlerCallback.bind(this)(type, ids); break;
        case actionTypes.remove:
            if (this.props.actionHandlerCallback && ids.length > 0) {
                let rows = content.rows.filter(row => ids.indexOf(row.columns['Id']) !== -1);
                this.props.actionHandlerCallback(type, rows);
            }
            break;
        case actionTypes.export:
            if (ids.length > 0) {
                this.actionHandlerCallbackDefault(type, ids);
            }
            break;
    }
}
export function renderContent() {
    const { content, page, pageSize, pageCount, sortBy, isDesk } = this.state;
    const { isEditAllowed } = this.props;
    let allowedEnumValues = this.getAllowedEnumValues();
    const actionsForAll = [
        {
            "title": i18next.t("open"),
            "btnClass": "",
            "type": actionTypes.preview,
            "sortIndex": 0
        }
    ];
    if (isEditAllowed) {
        actionsForAll.push({
            "title": i18next.t("remove"),
            "btnClass": "btn-secondary",
            "type": actionTypes.remove,
            "isMultiaction": true,
            "sortIndex": 0
        });
    }
    return (content && <div className="large-form doc-form">
            <Table allowedEnumValues={allowedEnumValues} onColumnFilter={this.onColumnFilter} allCount={content.allCount} allowDoubleClickAction={true} handleSortChange={this.handleSortChange} actionHandlerCallback={this.actionHandlerCallback} sortBy={sortBy} isDesk={isDesk} columns={content.columns} items={content.rows} showMoreLink={getCurrentUrlPath() === "/"} showPagination={false} page={page} pageSize={pageSize} pageCount={pageCount} handlePageChange={this.handlePageChange} handleChangePageSize={this.handleChangePageSize} actionsForAll={actionsForAll} />
        </div>);
}
export async function loadData(page = null, pageSize = null, sortBy = '', isDesk = false, filterValues = []) {
    ListOfContracts.loadData.bind(this)(1, 2147483646, sortBy, isDesk, filterValues);
}